import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { login } from "../redux/actions/authActions";
import { parseQrParams, buildQrQueryString } from "../utils/queryParams";
import AuthCard from "../components/AuthCard";
import Spinner from "../components/Spinner";

export default function LoginPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const { isLoggingIn, loginError } = useSelector((state) => state.auth);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const qrParams = parseQrParams(location.search);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username.trim() || !password.trim()) return;

    const ok = await dispatch(login(username.trim(), password));
    if (ok) {
      navigate(`/attendance${buildQrQueryString(qrParams)}`, { replace: true });
    }
  };

  return (
    <AuthCard title="Qr Scanning Attendance Web Portal" subtitle="Sign in to continue">
      <form onSubmit={handleSubmit} className="flex flex-col gap-5">
        <div className="flex flex-col gap-2">
          <label htmlFor="uname" className="text-xs font-semibold uppercase tracking-wide text-brand-muted">
            User Name
          </label>
          <div className="flex items-center gap-3 bg-white rounded-2xl shadow-[0_0_2em_#e6e9f9] px-4 py-3">
            <svg className="w-5 h-5 text-brand-navy shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="8" r="4" />
              <path d="M4 20c0-4 4-6 8-6s8 2 8 6" />
            </svg>
            <input
              id="uname"
              type="text"
              autoComplete="username"
              className="w-full outline-none text-brand-text placeholder:text-gray-400"
              placeholder="Enter your username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
        </div>

        <div className="flex flex-col gap-2">
          <label htmlFor="pw" className="text-xs font-semibold uppercase tracking-wide text-brand-muted">
            Password
          </label>
          <div className="flex items-center gap-3 bg-white rounded-2xl shadow-[0_0_2em_#e6e9f9] px-4 py-3">
            <svg className="w-5 h-5 text-brand-navy shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="5" y="11" width="14" height="9" rx="2" />
              <path d="M8 11V7a4 4 0 018 0v4" />
            </svg>
            <input
              id="pw"
              type="password"
              autoComplete="current-password"
              className="w-full outline-none text-brand-text placeholder:text-gray-400"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
        </div>

        {loginError && (
          <p className="text-sm text-red-600 bg-red-50 border border-red-100 rounded-xl px-3 py-2 text-center">
            {loginError}
          </p>
        )}

        <button
          type="submit"
          disabled={isLoggingIn}
          className="mt-2 flex items-center justify-center gap-2 bg-brand-navy hover:bg-brand-navy-dark disabled:opacity-70 transition-colors text-white font-bold rounded-3xl py-3.5 text-lg"
        >
          {isLoggingIn && <Spinner className="w-5 h-5" />}
          {isLoggingIn ? "Signing in..." : "Login"}
        </button>
      </form>
    </AuthCard>
  );
}
